import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { LayoutRoutingModule } from './layout-routing.module';
import { LayoutComponent } from './layout.component';
import { NavigationTreeComponent } from './navigation-tree/navigation-tree.component';
import { NotFound404Component } from '../not-found404/not-found404.component';
import { TranslocoModule } from '@jsverse/transloco';
import { MenuListItemComponent } from './menu-list-item/menu-list-item.component';
import { MenuListContainerComponent } from './menu-list-container/menu-list-container.component';
import { ContextualHelpComponent } from './contextual-help/contextual-help.component';
import { AccountModule } from '../shared/ui-components/account/account.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BreadcrumbModule } from '../shared/ui-components/breadcrumb/breadcrumb.module';
// import { preLoadTranslationsFiles } from '../preload';

@NgModule({
  declarations: [LayoutComponent, NavigationTreeComponent, NotFound404Component, MenuListItemComponent, MenuListContainerComponent, ContextualHelpComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule,
    LayoutRoutingModule,
    ReactiveFormsModule,
    AccountModule,
    BreadcrumbModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatButtonModule,
    MatSnackBarModule
  ],
  exports: [ContextualHelpComponent],
  // providers: [preLoadTranslationsFiles]
})
export class LayoutModule { }
